"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccordionBlockProperty = exports.accordionBlockPropertyDefinition = void 0;
exports.accordionBlockPropertyDefinition = {
    view: { label: 'Accordion Block' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['accordion-block-title', 'accordion-block-content'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'accordion-block',
};
const isAccordionBlockProperty = (prop) => {
    return prop.name === exports.accordionBlockPropertyDefinition.name;
};
exports.isAccordionBlockProperty = isAccordionBlockProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLWJsb2NrLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYWNjb3JkaW9uLWJsb2NrLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGlCQUFpQixFQUFFO0lBQ2xDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUUsQ0FBQyx1QkFBdUIsRUFBRSx5QkFBeUIsQ0FBQztTQUMvRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxpQkFBaUI7Q0FDUSxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=